import React, { Component } from "react";
 
class Conditions extends Component {
  render() {
    return (
      <div>
        <h2>Zber</h2>
        <p>
        Zber Vám oznámime pár dní vopred. Ovocie
      nazbierame popoludní a dodáme Vám na druhý
      deň, ale často sa môže stať, že ovocie bude
      ešte ráno na stromoch a večer na Vašom stole.
        </p>
        <h2>Dodávka a osobný odber</h2>
        <p>Dodávka od 10 kg ovocia je zdarma na tejto trase:
          Čierna Voda, Mostová, Vozokany, Tomášikovo, Jahodná,
          Dunajský Klátov, Malé Dvorníky a Dunajská Streda.</p>
        <p>Mimo tejto trasy môžeme priniesť naše vlastné
           ovocie do vášho domu, v závislosti od množstva
          za prepitné alebo 0,2 Eur / km.</p>
        <p>Môžete si tiež prevziať ovocie v našom bydlisku
          (Jilemnického 234/27, Dunajská Streda) alebo v 
          záhrade Orechová Potôň Lúky (v blízkosti bodu,
          kde sa stretáva Malý Dunaj a Čierna Voda).
        </p>
        <h2>Zapísanie</h2>
        <p>Objednávky vybavujeme podľa poradia. Vaše
          poradie a doba dozrievania ovocia je rozhodujúca
          v plánovaní nášho zberu. Snažíme sa Vám poskytnúť
          ovocie v správnom čase a v požadovanom množstve
          podľa našej najlepšej snahy. Väčšinou sme úspešní,
          ale niekedy sa stane, že keď Ste na rade pre Vás
          nie je vhodný čas (napr. výlet) alebo množstvo
          zapísaného ovocia je o niečo menej alebo o niečo
          viac (napr. 1-3 kg).
      </p>
      <p>
Ovocie je cenné, aby ho netrebalo dať na kompost</p>
              <ol>
          <li>Keď si zapíšete ovocie, prosím Vás povedzte nám,
              kedy Vám to nevyhovuje (napr. od 1. augusta
              do 5. augusta).</li>
          <li>Niekedy sa môže stať, že Vás známy prekvapí a 
              dostanete darček vo forme ovocia, prosím Vás
              buďte taký láskavý a povedzte nám, že chcete
              menej z ovocia alebo už vôbec nechcete.</li>
        </ol>
      </div>
    );
  }
}
 
export default Conditions;



// WEBPACK FOOTER //
// ./src/Conditions.js